import React from 'react';
import { ActionButtonMenuProps } from '../model';
import { MenuList } from '../../menuList';
import { MenuItem } from './menuItem';

export const ActionButtonMenu = React.forwardRef<HTMLUListElement, ActionButtonMenuProps>(({ items = [], onClose, ...props }, ref) => {
  return (
    <MenuList onClick={onClose} {...props} ref={ref}>
      {Array.isArray(items)
        ? items.map((item) =>
            typeof item.label === 'function' ? (
              item.label()
            ) : (
              <MenuItem disabled={item.disabled} key={item.id} onClick={item.onClick}>
                {item.label}
              </MenuItem>
            ),
          )
        : items}
    </MenuList>
  );
});
